import script from "./RequestNotificationsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestNotificationsModal.vue?vue&type=script&setup=true&lang=ts"

import "./RequestNotificationsModal.vue?vue&type=style&index=0&id=03e8712c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e8712c"]])

export default __exports__